import { createSlice } from '@reduxjs/toolkit';
import axios from 'utils/axios';
import { dispatch } from 'redux_data/store';
import { getFirstAndLastDateOfWeek } from 'utils/util'; 

const [start_date , end_date] = getFirstAndLastDateOfWeek();
const slice = createSlice({
  name: 'expense', // This is the name of the slice
  initialState: {
    hasError: null,
    isLoading: false,
    isLoadingDetail: false,
    start_date: start_date, 
    end_date: end_date,
    formValue: null,
    postDatas: [],
    fileDatas: [],
    datas: [],
    paymentDatas: [],
    data: {},
  },
  reducers: {
    noError(state) { // NO ERROR
      state.hasError = false;
    },
    unsetError(state) { // UNSET ERROR
      state.hasError = null;
    },
    hasError(state, action) { // HAS ERROR
      state.isLoading = false;
      state.hasError = JSON.stringify(action.payload);
    },
    startLoading: (state, action) => {
      state.isLoading = true;
    },
    startLoadingDetail: (state, action) => {
      state.isLoadingDetail = true;
    },
    setStartDate: (state, action) => {
      state.isLoading = false;
      state.start_date = action.payload;
    },
    setEndDate: (state, action) => {
      state.isLoading = false;
      state.end_date = action.payload;
    },
    setDatas: (state, action) => {
      state.isLoading = false;
      state.datas = action.payload;
    },
    setPaymentDatas: (state, action) => {
      state.isLoading = false;
      state.paymentDatas = action.payload;
    },
    setData: (state, action) => {
      state.isLoadingDetail = false;
      state.data = action.payload;
    },
    setFormValue: (state, action) => {
      state.formValue = action.payload;
    },
    setFileDatas: (state, action) => {
      state.fileDatas = action.payload;
    },
    setPostDatas: (state, action) => {
      state.postDatas = action.payload;
    },
  },
});

export const { 
    noError , 
    unsetError , 
    hasError, 
    startLoading , 
    startLoadingDetail , 
    setStartDate ,
    setEndDate ,
    setDatas , 
    setPaymentDatas ,
    setData ,
    setFormValue , 
    setFileDatas ,
    setPostDatas ,
} = slice.actions;

const endpoint = "/expense"

export function searchData({ data = {} , params = {} } = {data: {} , params: {}}) {
  return async (dispatch , getState) => {
    dispatch(slice.actions.startLoading());
    try {
      const state = getState();
      if(!data?.start_date){ data.start_date = state.expense.start_date} ;
      if(!data?.end_date){ data.end_date = state.expense.end_date} ;

      let endpointURL = `${endpoint}/search`;
      Object.keys(params).forEach(key => {
        if(endpointURL.includes("?")){
          endpointURL = `${endpointURL}&${key}=${params[key]}`;
        }else{
          endpointURL = `${endpointURL}?${key}=${params[key]}`;
        }
      })
      const response = await axios.post( endpointURL , data )?.then( resp => resp?.data);
      // console.log("searchData", response);
      if(response?.success){
        dispatch(slice.actions.setDatas(response.data));
      }else{
        dispatch(slice.actions.hasError(response));
      }
    } catch (error) {
      if(error?.response?.data){
        dispatch(hasError(error.response.data));
      }else if(error?.message){
        dispatch(hasError(error.message));
      }else{
        dispatch(hasError(error));
      }
    }
  };
}

export function searchPaymentData({ data = {} , params = {} } = {data: {} , params: {}}) {
  return async (dispatch , getState) => {
    dispatch(slice.actions.startLoading());
    try {
      const state = getState();
      // if(!data?.start_date){ data.start_date = state.expense.start_date} ;
      // if(!data?.end_date){ data.end_date = state.expense.end_date} ;

      let endpointURL = `payment_request/search`;
      Object.keys(params).forEach(key => {
        if(endpointURL.includes("?")){
          endpointURL = `${endpointURL}&${key}=${params[key]}`;
        }else{
          endpointURL = `${endpointURL}?${key}=${params[key]}`;
        }
      })
      const response = await axios.post( endpointURL , data )?.then( resp => resp?.data);
      // console.log("searchPaymentData", response);
      if(response?.success){
        dispatch(slice.actions.setPaymentDatas(response.data));
      }else{
        dispatch(slice.actions.hasError(response));
      }
    } catch (error) {
      if(error?.response?.data){
        dispatch(hasError(error.response.data));
      }else if(error?.message){
        dispatch(hasError(error.message));
      }else{
        dispatch(hasError(error));
      }
    }
  };
}

export function ocrData({formData}) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post(`${endpoint}/ocr`, formData )?.then( resp => resp?.data);
      // console.log("addData", response);
      if(response?.success){
        dispatch(slice.actions.noError());
        // dispatch(searchData());
      }else{
        dispatch(slice.actions.hasError(response));
      }
    } catch (error) {
      if(error?.response?.data){
        dispatch(hasError(error.response.data));
      }else if(error?.message){
        dispatch(hasError(error.message));
      }else{
        dispatch(hasError(error));
      }
    }
  };
}

export function addData({formData}) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post(`${endpoint}`, formData )?.then( resp => resp?.data);
      // console.log("addData", response);
      if(response?.success){
        dispatch(slice.actions.noError());
        dispatch(searchData());
      }else{
        dispatch(slice.actions.hasError(response));
      }
    } catch (error) {
      if(error?.response?.data){
        dispatch(hasError(error.response.data));
      }else if(error?.message){
        dispatch(hasError(error.message));
      }else{
        dispatch(hasError(error));
      }
    }
  };
}

export function editData({id, formData, encryptedPin}) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      if(encryptedPin){ axios.defaults.headers.common.pin = encryptedPin; }
      const response = await axios.patch(`${endpoint}/${id}`, formData )?.then( resp => resp?.data);
      // console.log("editData", response);
      if(response?.success){
        dispatch(slice.actions.noError());
        dispatch(searchData());
      }else{
        dispatch(slice.actions.hasError(response));
      }
    } catch (error) {
      if(error?.response?.data){
        dispatch(hasError(error.response.data));
      }else if(error?.message){
        dispatch(hasError(error.message));
      }else{
        dispatch(hasError(error));
      }
    }
  };
}

export function deleteData({item_list , encryptedPin}) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      // console.log(list_id , encryptedPin);
      if(encryptedPin){ axios.defaults.headers.common.pin = encryptedPin; }
      const response = await axios.put(`${endpoint}/` , { item_list: item_list })?.then( resp => resp?.data);;
      if(response?.success){
        dispatch(slice.actions.noError())
        dispatch(searchData());
      }else{
        dispatch(slice.actions.hasError(response));
      }
    } catch (error) {
      if(error?.response?.data){
        dispatch(hasError(error.response.data));
      }else if(error?.message){
        dispatch(hasError(error.message));
      }else{
        dispatch(hasError(error));
      }
    }
  };
}

export function postData({ data = {} , params = {} } = {data: {} , params: {}}) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      // let endpointURL = `${endpoint}/post_sales_data`;
      let endpointURL = `/expense_invoice/push`;
      Object.keys(params).forEach(key => {
        if(endpointURL.includes("?")){
          endpointURL = `${endpointURL}&${key}=${params[key]}`;
        }else{
          endpointURL = `${endpointURL}?${key}=${params[key]}`;
        }
      })
      const response = await axios.post( endpointURL , data )?.then( resp => resp?.data);
      // console.log("postData", response);
      if(response?.success){
        dispatch(slice.actions.noError());
        dispatch(searchData());
      }else{
        if(response?.data){
          dispatch(hasError(response.data));
        }else{
          dispatch(hasError(response));
        }
      }
    } catch (error) {
      if(error?.response?.data){
        dispatch(hasError(error.response.data));
      }else if(error?.message){
        dispatch(hasError(error.message));
      }else{
        dispatch(hasError(error));
      }
    }
  };
}

export default slice.reducer;
